export const TODO_COMMAND_EVENT = 'todo:command';

export type TodoCommand =
  | { type: 'complete_selection' }
  | { type: 'cancel_selection' }
  | { type: 'delete_selection' }
  | { type: 'select_all' }
  | { type: 'someday_on' }
  | { type: 'someday_off' }
  | { type: 'postpone_selection' }
  | { type: 'focus_quick_add' };

export function emitTodoCommand(command: TodoCommand) {
  window.dispatchEvent(new CustomEvent<TodoCommand>(TODO_COMMAND_EVENT, { detail: command }));
}
